import '@fontsource-variable/inter/wght.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { startServiceWorker } from './pwa/register.ts';
import './ui/tokens.css';
import './ui/app.css';
import './ui/orders.css';
import './ui/clients.css';
import './ui/visit.css';
import './ui/quotes.css';
import './ui/pwa.css';
import './ui/motion.css';

const root = document.getElementById('root');
if (!root) throw new Error('No se encontró el elemento raíz.');

if (import.meta.env.PROD) startServiceWorker();

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
